import React, { useContext, useState, useEffect } from 'react';
import { useNavigate, useParams  } from 'react-router-dom';

import { submitActivity, updateActivity, getActivity } from './ActivityClient';

import { CurrentUserContext } from 'Components/Participant/Auth/RequiresCurrentUserContext';

import LabelledInput from 'Components/Form/LabelledInput';
import LabelledSelect from 'Components/Form/LabelledSelect';

import Error from 'Components/Form/Error';

const TYPES = [
    { label: "Run", requiresKm: true },
    { label: "30 Minute workout", requiresKm: false, km: 4 },
    { label: "60 Minute workout", requiresKm: false, km: 8 },
    { label: "Cycle", requiresKm: true },
    { label: "Football match", requiresKm: false, km: 7 },
    { label: "Gym challenge", requiresKm: true },
    { label: "Row", requiresKm: true },
    { label: "Ski", requiresKm: true },
    { label: "Walk", requiresKm: true },
    { label: "Other exercise", requiresKm: true }
];

const KM_TO_MILES = 0.621371;

function AddKilometers ()
{
    const navigate = useNavigate ();
    const { activityId } = useParams ();

    const { currentUser } = useContext ( CurrentUserContext );
    
    const [ type, setType ] = useState ( TYPES[0].label );
    const [ typeIsStrava, setTypeIsStrava ] = useState ( false );
    const [ activityName, setActivityName ] = useState ( null );
    const [ km, setKm ] = useState ( 0 );
    const [ miles, setMiles ] = useState ( 0 );
    const [ participants, setParticipants ] = useState ( 1 );

    const [ isSubmitting, setIsSubmitting ] = useState ( false );
    const [ error, setError ] = useState ( { isError: false, message: null } );

    const [ isLoading, setIsLoading ] = useState ( false );
    const [ loadedActivity, setLoadedActivity ] = useState ( null );
    
    useEffect ( () => {

        if ( isLoading === false && activityId && currentUser && loadedActivity === null )
        {
            setIsLoading ( true );

            getActivity ( currentUser, activityId )
                .then ( response => {
                    setLoadedActivity ( response.data );

                    if ( response.data )
                    {
                        setActivityName ( response.data.name );
                        doSetType ( response.data.name );
                        setKmAndMiles ( response.data.distance );
                        setParticipants ( response.data?.participants ? response.data.participants : 1 );
                        console.log ( response.data );
                    }

                    setIsLoading ( false );
                    setError ( { isError: false, message: null } );
                } )
                .catch ( error => {
                    setLoadedActivity ( null );
                    setIsLoading ( false );
                    setError ( { isError: true, message: error?.message ? error.message : JSON.stringify ( error ) } )
                } );
        }

    }, [ isLoading, currentUser, loadedActivity, activityId ] );

    const doSubmit = async () =>
    {
        if ( isSubmitting === false )
        {
            setIsSubmitting ( true );
     
            if ( km > 100 )
            {
                if ( !window.confirm ( "You are submitting " + km + " kilometers, with " + participants + " participants, for a total of " + ( participants * km ) + " km. Is that right?" ) )
                {
                    setIsSubmitting ( false );
                    return;
                }
            }

            if ( activityId )
            {
                updateActivity ( currentUser, activityId, typeIsStrava === true ? activityName : type, Number ( km ), participants )
                    .then ( response => {
                        navigate ( "/participant/secure/log" );
                    } )
                    .catch ( error => {
                        setIsSubmitting ( false );
                        setError ( { isError: true, message: error?.message ? error.message : JSON.stringify ( error ) } )
                    } );
            }
            else
            {
                submitActivity ( currentUser, type, Number ( km ), participants )
                    .then ( response => {
                        navigate ( "/participant/secure/log" );
                    } )
                    .catch ( error => {
                        
                        setIsSubmitting ( false );
                        if ( error?.response?.data?.code === "NOT_STARTED" )
                        {
                            setError ( { isError: true, message: "The campaign has not yet started" } )
                        }
                        else if ( error?.response?.data?.code === "ENDED" )
                        {
                            setError ( { isError: true, message: "The campaign has ended" } )
                        }
                        else
                        {
                            setError ( { isError: true, message: error?.message ? error.message : JSON.stringify ( error ) } )
                        }
                    } );
            }
        }
    }

    const doSetType = ( type ) =>
    {
        if ( type?.trim ().toLowerCase ().includes ( "strava" ) )
        {
            setType ( null );
            setTypeIsStrava ( true );
        }
        else
        {
            console.log ( "SET TYPE" );
            console.log ( type );
            console.log ( TYPES );

            var foundType = TYPES.find ( t => t.label === type );

            if ( !foundType )
            {
                foundType = TYPES[0];
            }

            if ( foundType.requiresKm === false )
            {
                setKmAndMiles ( Number ( foundType.km ) );
            }

            setType ( type );
        }
    }

    const isKMEditable = () =>
    {
        return typeIsStrava === false && TYPES.find ( t => t.label === type ).requiresKm;
    }

    const setKmAndMiles = ( newKm ) =>
    {
        setKm ( newKm );

        if ( newKm !== null )
        {
            setMiles ( Number ( newKm * KM_TO_MILES ).toFixed ( 2 ) );
        }
    }

    const setMilesAndKm = ( newMiles ) =>
    {
        setMiles ( newMiles );

        if ( newMiles !== null )
        {
            setKm ( Number ( newMiles / KM_TO_MILES ).toFixed ( 2 ) );
        }
        else
        {
            setKm ( 0 );
        }
    }

    const updateParticipants = ( p ) =>
    {
        setParticipants ( p );
    }


    return  <div className="w-full m-auto">
                <h1>{ activityId ? "Edit" : "Add"} activity</h1>
                { error.isError && <Error message={error.message} /> }
                { typeIsStrava === false && <LabelledSelect label="Type" id="type" value={type} onChange={ ( newValue ) => doSetType ( newValue ) } options={ TYPES.map ( type => { return { value: type.label, label: type.label }; } ) } /> }
                { typeIsStrava === true && <LabelledInput label="Name" id="name" value={activityName} type="text" editable={ false } /> }
                <div className="flex flex-row gap-4">
                    <LabelledInput label="Kilometers" id="km" value={km} onChange={ ( newValue ) => setKmAndMiles ( newValue === "" ? null : Number ( newValue ) ) } type="number" editable={ isKMEditable () } />
                    <LabelledInput label="Miles" id="miles" value={miles} onChange={ ( newValue ) => setMilesAndKm ( newValue === "" ? null : Number ( newValue ) ) } type="number" editable={ isKMEditable () } />
                </div>
                {km > 100 && <div  className="p-2 mb-2 font-bold bg-pgyellow text-pgblack p-2 rounded-lg">Please ensure that you are entering kilometers and not meters</div>}
                <div className="flex flex-row gap-4">
                    <LabelledInput label="Number of participants" id="participants" value={participants} onChange={ ( newValue ) => updateParticipants ( Number ( newValue ) ) } type="number" />    
                </div>
                { participants > 1 && <p>The distance entered will be multiplied by the number of participants for the leaderboards. If the event included participants from other gyms, teams, or functions, each participant should log their own activities so their distances add to their teams on the leaderboards.</p> }

                <div className="flex flex-row gap-4">
                    <button onClick={ () => doSubmit () } disabled={ !(Number ( km ) > 0 && Number ( participants ) > 0) || isSubmitting === true }>Submit</button>
                    <button onClick={ () => navigate ( -1 ) }>Cancel</button>
                </div>
            </div>
}

export default AddKilometers;